<template>
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
               Email
              </th>
              <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
               Role
              </th>

              <th scope="col" class="relative px-6 py-3">
                <span class="sr-only">Edit</span>
              </th>
            </tr>
            </thead>
            <tbody v-if="users">
            <tr
                @click="() => handleEditUser(user)"
                v-for="(user, idx) in users"
                :key="user.id"
                class="cursor-pointer hover:bg-gray-100"
                :class="idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
              <!--              <template v-if="product.id === clientId">-->
              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ user.email }}
              </td>

              <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                {{ user.role }}
              </td>

              <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
<!--                <button @click.stop="() => handleEditUser(user)"  class="text-indigo-600 hover:text-indigo-900 mx-3">Edit</button>-->
                <button class="text-red-500 hover:text-red-900" @click.stop="() => handleDeleteUser(user)">
                  Delete
                </button>

              </td>

              <!--              </template>-->

            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <edit-user-window
        v-on:bam:closed="bigAssModalIsOpen = false"
        v-on:user:updated="bigAssModalIsOpen = false"
        v-if="bigAssModalIsOpen"
        :user="activeUser" />

  </div>
</template>

<script>
import EditUserWindow from "@/components/Users/EditUserWindow";
export default {
  name: "UsersViewTable",
  components: {EditUserWindow},
  props: ['users'],
  data() {
    return {
      bigAssModalIsOpen: false
    }
  },
  methods: {
    async handleDeleteUser(user) {
      this.$store.dispatch('showLoadingSpinner')

      try {
        await this.$store.dispatch('deleteUser', user)

      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
        this.$store.dispatch('hideLoadingSpinner')
      }
      this.$store.dispatch('hideLoadingSpinner')

    },
    async handleEditUser(user) {
      this.$store.dispatch('showLoadingSpinner')

      try {
        await this.$store.dispatch('getUser', user)
        this.bigAssModalIsOpen = true
      } catch (e) {
        this.$store.dispatch('createAlert', {
          type: 'danger',
          message: e
        })
      }
      this.$store.dispatch('hideLoadingSpinner')

    }
  },
  computed: {
    activeUser() {
      return this.$store.getters.getUserStoreUser
    }
  }
}
</script>

<style scoped>

</style>